import { useCurrentPageAccess } from "@/app/router";
import { Breadcrumbs } from "@/shared/components/layout/Breadcrumbs";
import { PageHeader } from "@/shared/components/layout/PageHeader";
import { UserTable } from "../components/UserTable";
export function UserListPage() {
  const { canWriteCurrentPage } = useCurrentPageAccess();
  return (
    <div>
      <Breadcrumbs />
      <PageHeader
        title="컨트롤 패널 유저 관리"
        description="컨트롤 패널 유저와 각 유저에 부여된 권한을 관리합니다."
      />
      <UserTable canWrite={canWriteCurrentPage} />
    </div>
  );
}

